import { firestoreAction } from 'vuexfire'
import {db} from "@/plugins/db";
import * as firebase from "firebase";
import {SoupLetterCategoryInterface, SoupLetterInterface} from "@/models/Games";
import {CrucigramaListInterface, PalabraInterface} from "@/models/Crucigrama";


interface StateInterface {
    soupLetters: SoupLetterInterface[];
    soupLettersCategories: SoupLetterCategoryInterface[];
    crucigrama: PalabraInterface[];
    crucigramaList: CrucigramaListInterface[];
}

export default {
    namespace: true,
    state:{
        soupLetters: [],
        soupLettersCategories: [],
        crucigrama:[],
        crucigramaList:[],
    },
    actions:{
        bindSoupLetters: firestoreAction(({ bindFirestoreRef }, order) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('soupLetters', db.collection('soupLetters').orderBy('createdAt', order))
        }),
        bindSoupLettersCategories: firestoreAction(({ bindFirestoreRef }) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('soupLettersCategories', db.collection('soupLettersCategories').orderBy('createdAt', 'desc'))
        }),
        createdSoupLetter: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('soupLetters').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        createdSoupLetterCategory: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('soupLettersCategories').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),


        // crucigrama


        createdCrucigrama: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('crucigrama').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        bindCrucigrama: firestoreAction(({ bindFirestoreRef }, order) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('crucigrama', db.collection('crucigrama').orderBy('createdAt', order))
        }),


        // crucigrama lista

        createdCrucigramaList: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('crucigramaList').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        bindCrucigramaList: firestoreAction(({ bindFirestoreRef }, order) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('crucigramaList', db.collection('crucigramaList').orderBy('createdAt', order))
        }),


    },
    getters:{
        crucigramaById: (state: StateInterface) => (id: string) => {
            return state.crucigrama.filter(e => e.crucigramaId === id)
        }

    }
}

